(() => {
  const bar = document.querySelector('[data-advance-sticky-atc]');
  if (!bar) return;
  bar.querySelector('[data-advance-sticky-dismiss]')?.addEventListener('click', () => { bar.hidden = true; });

  const refreshCart = async () => {
    try {
      const route = window.routes?.cart_url || '/cart';
      const response = await fetch(`${route}?sections=cart-drawer,cart-icon-bubble`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const sections = await response.json();
      const drawer = document.querySelector('cart-drawer');
      const rendered = sections['cart-drawer'];
      let updated = false;
      if (drawer && rendered) {
        const parsed = new DOMParser().parseFromString(rendered, 'text/html');
        const next = parsed.querySelector('#CartDrawer .drawer__inner');
        const current = drawer.querySelector('.drawer__inner');
        if (next && current) {
          current.replaceWith(next);
          drawer.classList.toggle('is-empty', parsed.querySelector('cart-drawer')?.classList.contains('is-empty') || false);
          updated = true;
        }
      }
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const next = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('#cart-icon-bubble');
        if (next) bubble.innerHTML = next.innerHTML;
      }
      if (updated && drawer && !drawer.classList.contains('active')) drawer.open();
    } catch (_) { /* Shopify cart remains authoritative; preserve its normal checkout flow. */ }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source }) => {
      if (source !== 'product-form') return;
      bar.hidden = true;
      return refreshCart();
    });
  }
})();
